import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
import { ArrowDown } from 'lucide-react';
export function Hero() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative min-h-screen flex flex-col items-center justify-center px-6 py-20 overflow-hidden bg-slate-950" data-id="element-109">
      {/* Ambient Background Glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[800px] bg-amber-900/20 rounded-full blur-[120px] pointer-events-none" data-id="element-110" />

      <div className="relative z-10 max-w-3xl mx-auto text-center space-y-12" data-id="element-111">
        <FadeIn data-id="element-112">
          <div className="space-y-6" data-id="element-113">
            <h1 className="text-4xl md:text-6xl font-bold text-white leading-tight tracking-tight" data-id="element-114">
              Si despiertas a las 3AM, <br data-id="element-115" />
              <span className="text-amber-400" data-id="element-116">NO te falta melatonina.</span>
            </h1>
            <p className="text-xl md:text-2xl text-slate-300 font-light leading-relaxed max-w-2xl mx-auto" data-id="element-117">
              Te despiertas. No sabes por qué… pero sabes lo que viene. Tu mente
              prende la luz interna y empieza a correr.
            </p>
          </div>
        </FadeIn>

        <FadeIn delay={200} data-id="element-118">
          <div className="relative mx-auto w-full max-w-md group" data-id="element-119">
            <div className="absolute -inset-1 bg-gradient-to-r from-amber-500 to-orange-600 rounded-2xl blur opacity-25 group-hover:opacity-40 transition duration-1000" data-id="element-120"></div>
            <img src="https://cdn.magicpatterns.com/uploads/842WJkm7L3aDehjq1TLWto/private_gemini-generated-image-1770140452642.png" alt="Club de las 3AM Kit en iPad" className="relative rounded-2xl shadow-2xl border border-slate-800 bg-slate-900 w-full" data-id="element-121" />
          </div>
        </FadeIn>

        <FadeIn delay={400} data-id="element-122">
          <div className="space-y-8" data-id="element-123">
            <p className="text-lg text-slate-400 max-w-xl mx-auto" data-id="element-124">
              Lo peor no es estar despierta. Lo peor es ese momento donde
              sientes que la noche se te voltea.
              <br data-id="element-125" />
              <br data-id="element-126" />
              <span className="text-amber-100 font-medium" data-id="element-127">
                Este mini kit existe para que a las 3AM no improvises.
              </span>
            </p>

            <Button onClick={scrollToPricing} className="animate-pulse-slow" data-id="element-128">
              Quiero dormir mejor hoy
            </Button>
          </div>
        </FadeIn>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 text-slate-600 animate-bounce" data-id="element-129">
        <ArrowDown size={24} data-id="element-130" />
      </div>
    </section>;
}